import { useEffect, useMemo } from 'react';
import { CuredApiPaths } from 'models/enums';
import Card from 'pages/InsightsPage/dashboards/Card';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';
import useFilteredData from 'pages/InsightsPage/dashboards/filtering/useFilteredData';
import DataGrid from 'pages/InsightsPage/visualizations/DataGrid';
import {
    getHeaderName,
    getValueFormatter,
    useGetRows,
    ValueFormatTypes,
} from 'pages/InsightsPage/visualizations/DataGrid/utils';

type Props = {
    filtersForApi: FiltersForApiState;
};

const VoiceCallMetricsBySendCard = ({ filtersForApi }: Props) => {
    const { getData, isError, isLoading, data } = useFilteredData({
        key: 'voice-dashboard/voice-metrics',
        path: CuredApiPaths.REPORT_VOICE_METRICS,
    });

    useEffect(() => {
        getData(filtersForApi);
    }, [filtersForApi, getData]);

    const tableData = data as {}[];

    const columns: any = useMemo(() => {
        if (!tableData?.length) return;

        const columnFields = Object.keys(tableData?.[0]);
        const columns = columnFields?.map((field) => ({
            field,
            flex: 1,
            headerName: getHeaderName(field),
            valueFormatter: ({ value }: { value?: string }) => {
                const getType = () => {
                    if (field.includes('rate')) return ValueFormatTypes.PERCENTAGE;
                    return null;
                };
                return getValueFormatter({ type: getType(), value });
            },
        }));

        return columns;
    }, [tableData]);

    const rows = useGetRows(tableData);

    return (
        <Card isError={isError} isLoading={isLoading} label="Campaign Performance">
            {/* Track metrics by send and follow up with your audience */}
            <DataGrid columns={columns} rows={rows} />
        </Card>
    );
};

export default VoiceCallMetricsBySendCard;
